module.exports = __webpack_public_path__ + "img/plan.8c9e68b7.png";